import React, { useState, useEffect } from 'react'
import { FetchGenders, FetchSizeCategories, FetchCreateArticleType } from '../../fetcher'
import AlertMessage from '../alertmessages/AlertMessageView';
import { CreateArticleTypeView } from './CreateArticleTypeView';

const CreateArticleTypeContainer = ({ handleCloseModal, openAlert }) => {
    const [genders, setGenders] = useState([]);
    const [sizeCategories, setSizeCategories] = useState([]);
    const [filename, setFilename] = useState("")
    const [image, setImage] = useState("")

    /**
     * Fetch call to set available gender options
    */
    useEffect(() => {
        FetchGenders(setGenders, openAlert)
    }, [])

    /**
     * Fetch call to set available sizeCategory options
    */
    useEffect(() => {
        FetchSizeCategories(setSizeCategories, openAlert)
    }, [])

    /**
     * Calls fetch to create articleType with new set values
     * @param {object} articleTypeToCreate
     */
    const handleSubmit = (articleTypeToCreate) => {
        articleTypeToCreate.FileName = filename
        articleTypeToCreate.Image = image
        FetchCreateArticleType(articleTypeToCreate, handleCloseModal, openAlert)
    }

    return (
        <CreateArticleTypeView handleSubmit={handleSubmit} genders={genders} sizeCategories={sizeCategories} setFilename={setFilename} setImage={setImage} />
    )
}

export { CreateArticleTypeContainer }